import "./TargetPriceComponent.scss";
import Template from "./TargetPriceComponent.html";
import {IComponentOptions, IFilterService, IOnDestroy, IOnInit, IRootElementService} from "angular";
import {ReplaySubject} from "rxjs";
import {TradingIdeasViewStore} from "../../../store/TradingIdeasViewStore";
import {SecurityUtil} from "../../../../js/util/SecurityUtil";
import {TradeIdeaRecord} from "../../../models/TradeIdeaRecord";

export const TradingIdeaTargetPrice = "tfTradingIdeaTargetPrice";

export function tradingIdeaTargetPrice(): IComponentOptions {
    return {
        template: Template,
        bindings: {
            store: "<",
        },
        controllerAs: "ctrl",
        controller: TradingIdeaTargetPriceController
    };
}

export class TradingIdeaTargetPriceController implements IOnInit, IOnDestroy {
    /** @Input */
    public readonly store: TradingIdeasViewStore;

    private readonly targetPrice$ = new ReplaySubject<string>(1);

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly $element: IRootElementService,
                       private readonly $filter: IFilterService) {

    }

    public $onInit(): void {
        this.watchComponentVisibleSource();
        this.watchTargetPrice();
    }

    private watchComponentVisibleSource() {
        this.store
            .currentModel
            .takeUntil(this.destroyed$)
            .map((model) => model.idea)
            .map((idea) => idea.targetPrice != null)
            .subscribe((visible) => {
                if (visible) {
                    this.$element.removeClass("hidden");
                } else {
                    this.$element.addClass("hidden");
                }
            });
    }

    private watchTargetPrice() {
        this.store
            .currentModel
            .takeUntil(this.destroyed$)
            .map((model) => model.idea)
            .filter((idea) => idea.targetPrice != null)
            .map((idea) => this.calculateTargetPriceDescription(idea))
            .subscribe((description) => this.targetPrice$.next(description));
    }

    private calculateTargetPriceDescription(idea: TradeIdeaRecord): string {
        const isIndex = SecurityUtil.isIndex(idea.underlying);
        const targetPrice = idea.targetPrice!;
        const absPrice = Math.abs(targetPrice);
        const drCr = targetPrice >= 0 ? "DR" : "CR";
        const targetPriceString = this.$filter("price")(absPrice, isIndex);
        const dollarPrefix = isIndex ? "" : "$";

        return `${dollarPrefix}${targetPriceString} ${drCr}`;
    }


    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();

    }
}
